export const ActivePassiveStatus = [
  { id: 1, name: "active", value: true },
  { id: 0, name: "passive", value: false },
];

export const RbhPbhStatus = [
  { id: 1, name: "rbh", value: 1 },
  { id: 0, name: "pbh", value: 0 },
];
